import React from 'react';
import { Collapse, Typography } from 'antd';
import { helpFAQS } from '@utils/contstant';

const { Panel } = Collapse;
const { Text } = Typography;

const FAQ = () => {
  const faqData = helpFAQS
  const renderNestedPanel = (children: any) => (
    <Collapse>
      {children.map((child:any, index:any) => (
        <Panel header={child.question} key={`child-${index}`}>
          <Text>{child.answer}</Text>
        </Panel>
      ))}
    </Collapse>
  );

  return (
    <div style={{ padding: '20px 0px' }}>
      <Collapse accordion>
        {faqData.map((faq, index) => (
          <Panel header={faq.question} key={index}>
            <Text>{faq.answer}</Text>
            {faq.children && renderNestedPanel(faq.children)}
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default FAQ;
